import axios from "axios";
import { createFormHeadersAdmin, createHeadersAdmin } from "../../../utils/Utils";
import { BASE_URL, BASE_URL_AI } from "../../../assets/constants/constants";

//! *******************************************************
//! ********************Drop Downs*************************
//! *******************************************************

//  class
export const getClassDD = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-class`, data, headers);
};
//  session
export const getSessionDD = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}session-list`, data, headers);
};
//   Subject by class
export const getSubjectByClassDD = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-subject-by-class`, data, headers);
};
//   Chapter by Subject nad class
export const getChapterBySubjectAndClassDD = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-chapters-by-subject`, data, headers);
};
//   Chapter by Subject nad class
export const getSubjectByClassLMSDD = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-subject-by-class-lms`, data, headers);
};
//   Chapter by Subject nad class
export const getChapterBySUbjectLMSDD = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-chapter-by-subject-lms`, data, headers);
};
//  Stream by Class
export const getStreamByClassDD = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}stream-dd`, data, headers);
};

//! *******************************************************
//! ********************Drop Downs*************************
//! *******************************************************

//! Subject Master
//  Create Subject
export const createSubjectAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}create-subject-master`, data, headers);
};
//  List Subject
export const getSubjectAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-all-subject`, data, headers);
};
//  Update Subject
export const updateSubjectAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-subjects`, data, headers);
};
//  Delete Subject
export const deleteSubjectAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}delete-subject`, data, headers);
};
//  Update Status Subject
export const updateSubjectStatusAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-subject-status`, data, headers);
};

//! Chapter Master
//  List Chapter
export const getChapterAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-chapter`, data, headers);
};
//  Create Chapter
export const createChapterAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}create-chapter`, data, headers);
};
//  Update Chapter
export const updateChapterAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-chapter`, data, headers);
};

//! Question Master
//  Generate Question with AI
export const generateQuestionWithAIApi = async (data) => {
  const headers = createHeadersAdmin();
  console.log(
    "API Call",
    `${BASE_URL_AI}?topic=${data?.chapter_id}&num_questions=${data?.quantity}&type=${data?.question_type}&class_id=${data?.class_id}&subject_id=${data?.subject_id}`,
  );
  return await axios.get(
    `${BASE_URL_AI}?topic=${data?.chapter_id}&num_questions=${data?.quantity}&type=${data?.question_type}&class_id=${data?.class_id}&subject_id=${data?.subject_id}`,
    data,
    headers,
  );
};

//  Create Question
export const createQuestionAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}create-question`, data, headers);
};
//  Update Question
export const updateQuestionAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-question`, data, headers);
};
//  Update Question Status
export const updateQuestionStatusAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-question-status`, data, headers);
};
//  Get Question
export const getQuestionAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-question`, data, headers);
};
//  Delete Question
export const deleteQuestionAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}delete-question`, data, headers);
};
//  Bulk Import Question
export const bulkImportQuestionAPI = async (data) => {
  const headers = createFormHeadersAdmin;
  return await axios.post(`${BASE_URL()}bulk-import-question`, data, headers);
};

//! Session Master
//  List Session
export const getSessionAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-session`, data, headers);
};
//  Create Session
export const createSessionAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}create-session`, data, headers);
};
//  Update Session
export const updateSessionAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-session`, data, headers);
};
//! Stream Master
//  List Session
export const getStreamAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-stream`, data, headers);
};
//  Create Session
export const createStreamAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}create-stream`, data, headers);
};
//  Update Session
export const updateStreamAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-stream`, data, headers);
};

//! E-Content Master
//  Create E-Content
export const createEContentAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}ebook-upload`, data, headers);
};
//  Update e-content
export const updateEContentAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-ebook`, data, headers);
};
//  Delete e-content
export const deleteEContentAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}delete-ebook`, data, headers);
};
//   get E Content
export const getEContentAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-e-content`, data, headers);
};

//! Nodal Master
//   get district dd
export const getDistrictListAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}district-dd`, data, headers);
};
export const createNodalCenterAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}create-nodal-center`, data, headers);
};
export const getNodalCenterListAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-nodal-center-list`, data, headers);
};
export const updateNodalCenterAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-nodal-center`, data, headers);
};
export const deleteNodalCenterAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}delete-nodal-center`, data, headers);
};

//********************************************************************
//!************************  RESULT   ********************************
//********************************************************************

//   get Result
export const getStudentResultAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-result`, data, headers);
};
//   get Result
export const getStudentResultLMSAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-result-student-lms`, data, headers);
};
//   get Result By Student
export const getResultByStudentAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-result-student`, data, headers);
};
//********************************************************************
//!************************  RESULT   ********************************
//********************************************************************

//! Division List
//   get division dd
export const getDivisionDDAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}division-dd`, data, headers);
};
//! District List By Division
//   get division dd
export const getDistrictByDivisionDDAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}district-division-dd`, data, headers);
};
//! LMS User Register
//   LMS
export const createLMSAdminAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}lms-register`, data, headers);
};
//! LMS User Update
//   LMS
export const updateLMSAdminAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}lms-update-user`, data, headers);
};
//! LMS User List
//   LMS
export const getLMSUserListPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}lms-users-list`, data, headers);
};
//! LMS User Permissions
//   LMS
export const getLMSUserPermissionAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}lms-user-permissions`, data, headers);
};
//! LMS User Update Permissions
//   LMS
export const updateLMSUserPermissionAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-lms-user-permissions`, data, headers);
};

//! Add Previous Year Questions
export const addLMSPreviousYearQuestionAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}lms-add-previous-year-question`, data, headers);
};
//! Update Previous Year Questions
export const updateLMSPreviousYearQuestionAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}lms-update-previous-year-question`, data, headers);
};
//! List Previous Year Questions
export const listLMSPreviousYearQuestionAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}lms-list-previous-year-question`, data, headers);
};

//!List Student Questions
export const listLMSStudentQuestionAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}lms-list-student-question`, data, headers);
};

//!Get Subject Specialist Chapter List
export const getLMSSubjectSpecificChapterAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}subject-specific-chapter-list`, data, headers);
};

//!Get getStudentQueryListAPI List
export const getStudentQueryListAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}student-query-list-admin`, data, headers);
};

export const replyStudentQueryApi = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}student-query-reply`, data, headers);
};
